import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
          >
            <span className="text-2xl font-heading font-bold text-primary-500">
              韩漫之家
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === `/category/${cat.id}`
                    ? 'text-primary-500 bg-primary-50 font-medium'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
            aria-label="菜单"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-2.5 text-sm rounded-lg transition-colors duration-200 ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`px-4 py-2.5 text-sm rounded-lg transition-colors duration-200 ${
                  location.pathname === `/category/${cat.id}`
                    ? 'text-primary-500 bg-primary-50 font-medium'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2.5 text-sm rounded-lg transition-colors duration-200 ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-primary-50 font-medium'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}

export default Navbar;